export default "__VITE_ASSET__D$gGpkOs__"